import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromReducer from './integrated-ireckon-room.reducer';
import * as fromState from './integrated-ireckon-room.state';

import { LocationsRouterStoreSelectors } from '../router';

export const selectIntegratedIReckonRoomState =
  createFeatureSelector<fromState.IntegratedIReckonRoomState>('integratedIReckonRoom');

export const selectIntegratedIReckonRoomIds = createSelector(
  selectIntegratedIReckonRoomState,
  fromReducer.selectIntegratedIReckonRoomIds
);

export const selectIntegrationIReckonRoomEntities = createSelector(
  selectIntegratedIReckonRoomState,
  fromReducer.selectIntegratedIReckonRoomEntities
);

export const selectAllIntegratedIReckonRooms = createSelector(
  selectIntegratedIReckonRoomState,
  fromReducer.selectAllIntegratedIReckonRooms
);

export const selectIntegratedIReckonRoomForRoom = createSelector(
  LocationsRouterStoreSelectors.selectRoomId,
  selectIntegrationIReckonRoomEntities,
  (roomUniqueId, entities) => entities[roomUniqueId]
);

export const selectIntegratedIReckonRoomForRoomLoaded = createSelector(
  selectIntegratedIReckonRoomForRoom,
  (room) => !!room
);
